// eslint-disable-next-line no-unused-vars
import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Autoplay } from 'swiper/modules';
import resolveConfig from 'tailwindcss/resolveConfig';

const twConfig = resolveConfig('/tailwind.config.js');
const body = document.querySelector('body');
const remValue = window.getComputedStyle(body, null).getPropertyValue('font-size');
const gap = parseInt(twConfig.theme.spacing['4'], 10) * parseInt(remValue, 10);

export default function initSwiper() {
    const allSwipers = document.querySelectorAll('[data-swiper]');

    allSwipers.forEach((element) => {
        const swiperTitle = element.getAttribute('data-swiper');
        const editableSliders = ['industries'];
        const isEditableSlider = editableSliders.find((editableSlide) => editableSlide === swiperTitle);
        const swiperContainer = [];

        if (isEditableSlider) {
            // Hide cmeleonExternalCreateBlockContainer when there is atleast one slide to prevent issues;
            const allItems = document.querySelectorAll(`[data-swiper=${swiperTitle}] .cmeleon-block-content`);
            const cmeleonExternalCreateBlockContainer = document.querySelector(`[data-swiper=${swiperTitle}] .cmeleon-external-create-block-container`);

            if (allItems.length > 0 && cmeleonExternalCreateBlockContainer !== 'undefined' && cmeleonExternalCreateBlockContainer !== null) {
                cmeleonExternalCreateBlockContainer.classList.add('hidden');
            }
            // Add swiper-slide class to slides which are editable via front-end
            allItems.forEach((item) => {
                item.classList.add('swiper-slide');
            });
        }

        // Set default swiper settings
        const swiperSettings = {
            modules: [Navigation, Pagination, Thumbs, Autoplay],
            watchOverflow: true,
            loop: false,
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        };

        // Add or override slide specific settings
        switch (swiperTitle) {
            case 'industries':
                swiperSettings.slidesPerView = 2;
                swiperSettings.spaceBetween = gap;
                swiperSettings.breakpoints = {
                    [parseInt(twConfig.theme.screens.sm, 10)]: {
                        slidesPerView: 4,
                    },
                    [parseInt(twConfig.theme.screens.md, 10)]: {
                        slidesPerView: 6,
                    },
                    [parseInt(twConfig.theme.screens.lg, 10)]: {
                        slidesPerView: 7,
                    },
                };
                break;
            case 'related-products':
            case 'related-recipes':
                swiperSettings.spaceBetween = gap;
                swiperSettings.navigation = {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev',
                };
                swiperSettings.breakpoints = {
                    [parseInt(twConfig.theme.screens.sm, 10)]: {
                        slidesPerView: 2,
                    },
                    [parseInt(twConfig.theme.screens.lg, 10)]: {
                        slidesPerView: 4,
                    },
                };
                break;
            case 'highlight':
            case 'crosslink-highlight':
                swiperSettings.navigation = false;
                swiperSettings.loop = true;
                swiperSettings.autoplay = {
                    delay: 5000
                };

                // Loop and set heights of elements.
                let swiperHeight = 0;
                const allItems = document.querySelectorAll(`[data-swiper=${swiperTitle}] .swiper-slide`);
                allItems.forEach((item) => {
                    swiperHeight = swiperHeight <= item.offsetHeight ? item.offsetHeight : swiperHeight;
                });

                allItems.forEach((item) => {
                    item.style.height = `${swiperHeight}px`;
                });

                break;
            case 'crosslink-image':
                swiperSettings.spaceBetween = gap;
                swiperSettings.navigation = {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev',
                };
                swiperSettings.breakpoints = {
                    [parseInt(twConfig.theme.screens.sm, 10)]: {
                        slidesPerView: 2,
                    },
                    [parseInt(twConfig.theme.screens.lg, 10)]: {
                        slidesPerView: 4,
                    },
                };
                break;
            case 'crosslink-default':
                swiperSettings.spaceBetween = gap;
                swiperSettings.navigation = {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev',
                };
                swiperSettings.breakpoints = {
                    [parseInt(twConfig.theme.screens.sm, 10)]: {
                        slidesPerView: 2,
                    },
                    [parseInt(twConfig.theme.screens.lg, 10)]: {
                        slidesPerView: 3,
                    },
                };
                break;
            case 'crosslink-text-image':
                swiperSettings.spaceBetween = gap;
                swiperSettings.navigation = {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev',
                };
                swiperSettings.breakpoints = {
                    [parseInt(twConfig.theme.screens.lg, 10)]: {
                        slidesPerView: 2,
                    },
                };
                break;
            default:
                break;
        }

        swiperContainer[element.getAttribute('data-swiper')] = new Swiper(`[data-swiper="${element.getAttribute('data-swiper')}"]`, swiperSettings);
    });
}

export function initProductDetailSwiper() {
    const productSliderElement = document.querySelector('[data-product-swiper="product-detail"]');

    if (productSliderElement !== null) {
        const productThumbsSliderElement = document.querySelector('[data-product-swiper="product-detail-thumbs"]');

        const productSwiperOptions = {
            modules: [Navigation, Pagination, Thumbs, Autoplay],
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: gap,
        };

        if (productThumbsSliderElement !== null) {
            const productThumbSwiper = new Swiper(productThumbsSliderElement, {
                slidesPerView: 4,
                freeMode: true,
                spaceBetween: gap * 0.5,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });

            productSwiperOptions.thumbs = {
                swiper: productThumbSwiper,
            };
        }

        new Swiper(productSliderElement, productSwiperOptions);
    }
}
